import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as FacilitiesActions from '../../../actions/facilities_actions';
import { bindActionCreators } from 'redux';
import { ModalDialogCommon } from '../../modal_dialog_common';
import { validate } from '../../../validations';
import Header from '../../../components/header';
let screenIdentifier = 'addnewAdmin';
import InputMask from 'react-input-mask';
import _ from 'lodash';
import { cutom_utils } from '../../../ucd_utils/util';
import Modal from 'react-modal';
import * as SettingScreen from '../../../actions/settingScreen_actions';

export var AddNewAdmin = React.createClass({
    getInitialState() {
        return {
            showAddAdminSuccessModal: false,
            showFailureModel: false,
            modal_msg: null,
            form_submited: false,
            mobileCssClass: "inputText",

            //// Password verification
            //update: false,
            //invalidPass: true,
            //passwordVerifiedTrigger: false
        }
    },

    componentWillMount() {

    },

    componentWillReceiveProps(nextProps) {

        if (this.state.form_submited && nextProps.FacilitiesDetails.FaciliteAdmin) {
            nextProps.FacilitiesDetails.FaciliteAdmin.status == 200 ? this.setState({ showAddAdminSuccessModal: true, modal_msg: "Admin record has been added successfully." }) : this.setState({ showFailureModel: true, modal_msg: nextProps.FacilitiesDetails.FaciliteAdmin.message });
            nextProps.FacilitiesDetails.FaciliteAdmin = null;
        }
    },

    email_validate(event) {
        let email = event.target.value;
        let isValidEmail = validate.email(email);
        isValidEmail ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    phon_validate(event) {
        let mobile = event.target.value.replace(/ /g, "");
        let isValidMobile = validate.phone(mobile);
        isValidMobile ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    no_empty(event) {
        let value = event.target.value;
        let isEmptyValue = validate.notEmpty(value);
        isEmptyValue ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },
    selectionChanged(event) {
        event.target.value != "" ? event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown' : event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';
    },

    closebox() {
        this.setState({ showAddAdminSuccessModal: false, adminerr: false, showFailureModel: false });
    },
    closeBoxOnScuess() {
        this.refs.firstName.value = '';
        this.refs.lastName.value = '';
        this.refs.mobile.state.value = '';
        this.refs.email.value = '';
        this.refs.designation.value = "";
        this.setState({ showAddAdminSuccessModal: false, adminerr: false, showFailureModel: false });
    },
    remove_error(event) {
        event.target.type === "text" ? event.target.className = 'inputText' : event.target.className = '';
    },
    sendAddStaffInvitaion() {

        //var facility_id =  window.location.search ? validate.getUrlParam('id') : window.location.hash === "#new" ?this.props.FacilitiesDetails.FaciliteCreateDeatils.data.id:this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;

        var facility_id = this.props.UserDetails.selectdUserFacilityID;
        let firstName = this.refs.firstName.value.trim(),
            lastName = this.refs.lastName.value.trim(),
            mobile = this.refs.mobile.state.value.replace(/ /g, ""),
            email = this.refs.email.value.trim(),
            facilityRoleId = this.refs.designation.value.trim();

        // facilityRoleId = this.refs.designation.value.trim();


        // therapist=this.refs.therapist.value.trim();

        let iEmailTrue = validate.email(email);
        let isPhoneTrue = validate.phone(mobile);
        !facilityRoleId.length ? this.refs.designation.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom' : this.refs.designation.parentElement.parentElement.parentElement.className = 'aj-dropdown';

        !firstName.length ? this.refs.firstName.className = "inputText error" : this.refs.firstName.className = "inputText";
        !lastName.length ? this.refs.lastName.className = "inputText error" : this.refs.lastName.className = "inputText";
        // !facilityRoleId.length ? this.refs.designation.className = "error" : "";
        // !therapist.length ? this.refs.therapist.className += " error" : "";
        !iEmailTrue ? this.refs.email.className = "inputText error" : "inputText";
        !isPhoneTrue ? this.setState({ mobileCssClass: "inputText error" }) : this.setState({ mobileCssClass: "inputText" });

        if (firstName.length === 0 || lastName.length === 0 || mobile.length === 0 || email.length === 0 || facilityRoleId.length === 0) {
            this.setState({ showFailureModel: true, modal_msg: "Please enter necessary fields to proceed." });
            return false;
        }

        if (firstName.length && lastName.length && mobile.length && iEmailTrue && isPhoneTrue && facilityRoleId.length) {
            var data = {
                "firstName": firstName,
                "lastName": lastName,
                "mobile": mobile,
                "email": email,
                "createdBy":
                {
                    "id": this.props.UserDetails.loginData.data.id,
                    "role": { "id": this.props.UserDetails.selectedUserRoleID }
                },
                "facility": {
                    "id": facility_id
                },
                //"role": { "id": facilityRoleId },
                "role": { "id": 2 },
                "facilityRole": { "id": facilityRoleId }
            }
            this.setState({ form_submited: true });
            this.props.Dispatch(FacilitiesActions.createFaclityAdmin(data));
        }
        else {

            this.setState({ showFailureModel: true, modal_msg: "Please enter necessary fields to proceed." });
        }


    },

    //// Password verification
    // removeCancelPrompt() {
    //     this.setState({
    //         update: false
    //     })
    //     this.props.router.goBack();
    // },

    render() {

        var getYrs = cutom_utils.getYears();
        var yearOptions = getYrs.map(function (years) {
            return <option key={years}
                value={years}>{years}</option>;
        });

        return (
            <div>
                <Header screenIdentifier={screenIdentifier} />
                <div className="row">
                    <div className="col-xs-8 no-padding staff-recovery">
                        <div className="row">
                            <div className="col-xs-6 padding-right-20">
                                <div className="input-group">
                                    <input type="text" className="inputText" ref="firstName" onFocus={this.remove_error} onBlur={this.no_empty} maxLength="64" required />
                                    <span className="floating-label">First Name</span>
                                </div>
                            </div>
                            <div className="col-xs-6 no-padding ">
                                <div className="input-group">
                                    <input type="text" className="inputText" ref="lastName" onFocus={this.remove_error} onBlur={this.no_empty} maxLength="64" required />
                                    <span className="floating-label">Last Name</span>
                                </div>
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-xs-12 no-padding ">
                                <div className="input-group">
                                    <InputMask type="text" className={this.state.mobileCssClass} onFocus={this.remove_error} onBlur={this.phon_validate} ref="mobile" required mask="999 999 9999" maskChar={null}></InputMask>
                                    <span className="floating-label">Phone</span>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 no-padding ">
                                <div className="input-group">
                                    <input type="text" className="inputText" onFocus={this.remove_error} onBlur={this.email_validate} ref="email" required />
                                    <span className="floating-label">Email</span>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 no-padding ">
                                <div className="aj-dropdown">
                                    <div className="source">
                                        <div className="question-selection">
                                            <select ref="designation" onChange={this.selectionChanged} onFocus={this.selectionChanged} onBlur={this.selectionChanged} required>
                                                {/* <option value="" default>Clinic Role</option> */}
                                                <option value="" default> Professional Role </option>
                                                {/* <option value="3" >Psychiatrist  Support Staff</option>
                                                <option value="4" >Therapist</option>
                                                <option value="6" >Administrative Staff</option>
                                                <option value="5" >Other Support Staff</option> */}
                                                <option value="9" >Clinician/Therapist</option>
                                                <option value="10" >Prescriber/Psychiatrist/Other Medical Personnel</option>
                                                <option value="11" >Clinical Supervisor/Team Lead</option>
                                                <option value="12" >Clinic Coordinator</option>
                                                <option value="13" >Administrative Support Staff</option>
                                                <option value="14" >Family Advocate</option>
                                                <option value="15" >Peer Support Specialist</option>
                                                <option value="16" >Case Manager/Recovery Coach</option>
                                                <option value="17" >Supported Education & Employment Specialist</option>
                                                <option value="18" >Program Director</option>
                                                <option value="19" >Research Staff/Site Coordinator</option>
                                                <option value="20" >Other</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/*<div className="row no-margin">
                                         <button ref="previlizedUser" value='false' >Add more Admin</button>
                                    </div>*/}


                </div>






                <div className="row">
                    <div className="col-sm-12 no-padding recovery-buttons">

                        <button className="gray-button" onClick={this.sendAddStaffInvitaion}>SEND INVITATION</button>

                    </div>
                </div>
                {/*//// Password verification*/}
                {/*<Modal ref='deleteAddressModal' isOpen={this.state.update} className='delete-prompt modalPopup' contentLabel='modalPopup'>
                    <div className="popup-content profile text-center">
                        <p className='main_header'>
                            Please enter your password to proceed.
                    </p>
                        <div>
                            <div className="input-group">
                                <input type="password" ref="oldPassword" className="inputText" onChange={this.clearInvalidPass} onKeyPress={this.handleKeyPress} required />
                                <span className="floating-label">PASSWORD</span>
                                <span className={this.state.invalidPass ? 'hidden' : 'error'} > .</span>
                            </div>
                            <input type='button' value='SUBMIT' className='button button-primary btn-submit gray-button' ref='deleteBtn' onClick={this.ConfirmPrompt} />
                            <input type='button' value='CANCEL' className='button button-primary btn-submit white-button' ref='deleteCancelBtn' onClick={this.removeCancelPrompt} />
                        </div>
                    </div>
                </Modal>*/}
                <div> {this.state.showAddAdminSuccessModal ? <ModalDialogCommon message={this.state.modal_msg} action={this.closeBoxOnScuess} /> : ""}</div>
                <div> {this.state.showFailureModel ? <ModalDialogCommon message={this.state.modal_msg} action={this.closebox} /> : ""}</div>
            </div>

        );
    }
});


let mapStateToProps = (state) => {
    return {
        UserDetails: state.User,
        FacilitiesDetails: state.Facilites,
        //// Password verification
        //VerifyResponse: state.Setting.verification,

    };
};

let mapDispatchToProps = (dispatch) => ({
    FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(AddNewAdmin));



/** WEBPACK FOOTER **
 ** ./src/components/admin/clinicSettings/addNewAdmin.js
 **/